// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const flygon: PokeData = {
  "id": 330,
  "name": "flygon",
  "height": 20,
  "weight": 820,
  "base_experience": 234,
  "types": [
    PokeType.GROUND,
    PokeType.DRAGON
  ],
  "api_moves": [
    "sand-attack",
    "bite",
    "supersonic",
    "sonic-boom",
    "hyper-beam",
    "earthquake",
    "fissure",
    "dig",
    "screech",
    "bide",
    "rock-slide",
    "feint-attack",
    "mud-slap",
    "outrage",
    "sandstorm",
    "dragon-breath",
    "crunch",
    "uproar",
    "superpower",
    "astonish",
    "sand-tomb",
    "dragon-claw",
    "dragon-dance",
    "feint",
    "bug-buzz",
    "dragon-rush",
    "earth-power",
    "bulldoze",
    "dragon-tail",
    "boomburst",
    "laser-focus"
  ],
  "moves": [
    "bite",
    "supersonic",
    "earthquake",
    "fissure",
    "rock-slide",
    "mud-slap",
    "outrage",
    "sandstorm",
    "dragon-breath",
    "crunch",
    "superpower",
    "dragon-claw",
    "dragon-dance"
  ],
  "evolution_chain": {
    "id": 166,
    "item": null,
    "species": [
      {
        "name": "trapinch",
        "order": 356,
        "types": [
          PokeType.GROUND
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "vibrava",
        "order": 357,
        "types": [
          PokeType.GROUND,
          PokeType.DRAGON
        ],
        "evolves_from_species_id": 328,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 35,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "flygon",
        "order": 358,
        "types": [
          PokeType.GROUND,
          PokeType.DRAGON
        ],
        "evolves_from_species_id": 329,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 45,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 114,
    "speed": 143,
    "ability_power": 143
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
